module.exports = __webpack_public_path__ + "static/img/网络自智_0.1d85af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/网络自智_0.png
// module id = pT9n
// module chunks = 1